const AboutPage = () => {
  return (
    <div className="min-h-screen py-12" data-testid="about-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-light text-white mb-4" data-testid="page-title">درباره ARYA MOHAJER ASIA</h1>
          <p className="text-zinc-400">مرجع تخصصی مهاجرت، تحصیل و کار در خارج از کشور</p>
          <div className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full">
            <span className="text-[#D4AF37] font-medium">✓</span>
            <span className="text-zinc-300">جزو برترین نماینده‌های شرکت آی‌سف (ICEF)</span>
          </div>
        </div>

        <div className="glass-effect border border-white/10 rounded-2xl p-8 md:p-12 mb-12">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl font-medium text-white mb-6">ما کی هستیم؟</h2>
            <p className="text-zinc-300 leading-relaxed mb-6">
              ARYA MOHAJER ASIA یک مرجع جامع و تخصصی برای ارائه خدمات مهاجرتی، تحصیلی و کاری است. ما با ارائه اطلاعات دقیق و به‌روز درباره کشورها، دانشگاه‌ها و فرصت‌های شغلی، به متقاضیان مهاجرت کمک می‌کنیم تا بهترین تصمیم را برای آینده خود بگیرند.
            </p>
            <p className="text-zinc-300 leading-relaxed">
              با تیمی متشکل از مشاوران مجرب و حرفه‌ای، ما آماده راهنمایی شما در تمام مراحل مهاجرت هستیم - از انتخاب کشور و دانشگاه گرفته تا اخذ پذیرش و ویزا.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="glass-effect border border-white/10 rounded-2xl p-8 text-center">
            <div className="text-4xl font-bold text-[#D4AF37] mb-2">1000+</div>
            <div className="text-zinc-400">پذیرش موفق</div>
          </div>
          <div className="glass-effect border border-white/10 rounded-2xl p-8 text-center">
            <div className="text-4xl font-bold text-[#D4AF37] mb-2">20</div>
            <div className="text-zinc-400">کشور مقصد</div>
          </div>
          <div className="glass-effect border border-white/10 rounded-2xl p-8 text-center">
            <div className="text-4xl font-bold text-[#D4AF37] mb-2">100+</div>
            <div className="text-zinc-400">دانشگاه معتبر</div>
          </div>
        </div>

        <div className="glass-effect border border-white/10 rounded-2xl p-8 md:p-12">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl font-medium text-white mb-6">چرا ما را انتخاب کنید؟</h2>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1">•</span>
                <div>
                  <h3 className="text-white font-medium mb-1">مشاوران مجرب و حرفه‌ای</h3>
                  <p className="text-sm text-zinc-400">تیم ما از مشاورانی با سال‌ها تجربه در زمینه مهاجرت تشکیل شده است</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1">•</span>
                <div>
                  <h3 className="text-white font-medium mb-1">اطلاعات جامع و به‌روز</h3>
                  <p className="text-sm text-zinc-400">اطلاعات کامل و به‌روز از 20 کشور برتر در یک پلتفرم</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1">•</span>
                <div>
                  <h3 className="text-white font-medium mb-1">پشتیبانی مستمر</h3>
                  <p className="text-sm text-zinc-400">همراهی شما از ابتدا تا اخذ پذیرش و ویزا</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1">•</span>
                <div>
                  <h3 className="text-white font-medium mb-1">نرخ موفقیت بالا</h3>
                  <p className="text-sm text-zinc-400">بیش از 95% متقاضیان ما به پذیرش و ویزا دست یافته‌اند</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;